import React from 'react';
import { Grid, Paper, LinearProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { AppHeader } from '../../components/appHeader/appHeader';
import { useStyles } from './style';
import { ApplicationState } from '../../stores';

interface Props {
  children: React.ReactNode;
}

export default function AppLayoutComponent({ children }: Props) {
  const appLayoutStyles = useStyles();
  const isLoading = useSelector<ApplicationState, boolean>(state => state.loader.loading);

  return (
    <Grid container className={appLayoutStyles.layout}>
      <Grid item xs={12}>
        <AppHeader />
      </Grid>
      <Grid item xs={12} className={appLayoutStyles.loadingBarRow}>
        {isLoading ? <LinearProgress className={appLayoutStyles.loadingBar} /> : null}
      </Grid>
      <Grid item xs={12} className={appLayoutStyles.contentRow}>
        <Paper elevation={3} className={appLayoutStyles.paper}>
          {children}
        </Paper>
      </Grid>
    </Grid>
  );
}
